import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const AnimatedImage = ({ src, alt, spanClass, onClick }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 1.15 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 1.4, delay: 0.3, ease: "easeOut" }}
      className={`relative w-full overflow-hidden cursor-pointer group ${spanClass}`}
      onClick={onClick}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-auto block transition-transform duration-500 group-hover:scale-105"
      />
    </motion.div>
  );
};

export default function ParallaxGallery({ gallery, title }) {
  const [selectedImage, setSelectedImage] = useState(null);

  if (!gallery || gallery.length === 0) return null;

  return (
    <section className="w-full bg-zinc-900 flex flex-col items-center py-20 md:py-40 px-4 md:px-12">
      <div className="w-full max-w-400 grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-24 items-start">
        {gallery.map((image, index) => {
          const mod = index % 4;
          const spanClass = (mod === 0 || mod === 3) ? "md:col-span-1" : "md:col-span-2";

          return (
            <AnimatedImage
              key={index}
              src={image}
              alt={`${title} showcase ${index + 1}`}
              spanClass={spanClass}
              onClick={() => setSelectedImage(image)}
            />
          );
        })}
      </div>

      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 md:p-12 cursor-pointer"
          >
            <motion.img
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", damping: 25, stiffness: 200 }}
              src={selectedImage}
              alt="Enlarged showcase"
              className="max-w-full max-h-full object-contain shadow-2xl"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}